import { render, staticRenderFns } from "./WizardFile.vue?vue&type=template&id=4c67d82a&"
import script from "./WizardFile.vue?vue&type=script&lang=js&"
export * from "./WizardFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports